import RaffleDetails from "../components/RaffleDetails"

const RafflesPublicDetails = () => {
  return (<RaffleDetails />)
}

export default RafflesPublicDetails